import { render, staticRenderFns } from "./noBorderTable.vue?vue&type=template&id=5604fc86&scoped=true"
import script from "./noBorderTable.vue?vue&type=script&lang=js"
export * from "./noBorderTable.vue?vue&type=script&lang=js"
import style0 from "./noBorderTable.vue?vue&type=style&index=0&id=5604fc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5604fc86",
  null
  
)

export default component.exports